// 公共的扩展函数
const mixin = {
  data() {
    return {
      formItemLayout: {
        labelCol: { lg: { span: 4 }, sm: { span: 8 } },
        wrapperCol: { lg: { span: 20 }, sm: { span: 16 } }
      }
    }
  },
  methods: {
    /**
     * 统一显示网络返回的错误信息
     * @param reason
     */
    showNetWorkErrorMessage(reason) {
      this.getLogUtils().errorWithTag('网络错误', reason)
      if (reason && reason.msg) {
        this.$message.error(reason.msg)
      }
    },
    /**
     * 统一跳转页面
     * @param name
     * @param query
     * @param params
     */
    openNewPage(name, query, params) {
      this.$router.push({
        name: name,
        query: { ...query },
        params: { ...params }
      })
    },
    replacePage(name, query, params) {
      this.$router.replace({
        name: name,
        query: { ...query },
        params: { ...params }
      })
    },
    backEvent() {
      if (window.history.length <= 1) {
        this.$router.push({ path: '/' })
        return false
      } else {
        this.$router.go(-1)
      }
    },
    /**
     * 获取页面传递过来的参数
     * @returns {{}}
     */
    getPageParams() {
      return { ...this.$route.query, ...this.$route.params }
    },
    /**
     * 统一跳转新窗口页面
     * @param name
     * @param query
     * @param params
     */
    openNewWindowPage(name, query, params) {
      let Logistics = this.$router.resolve({
        name: name,
        query: { ...query },
        params: { ...params }
      })
      window.open(Logistics.href, '_blank')
    },

    /**
     * 统一跳转页面---页面路径
     * @param name
     * @param query
     * @param params
     */
    openPathNewPage(path, query, params) {
      this.$router.push({
        path: path,
        query: { ...query },
        params: { ...params }
      })
    }
  }
}
export default mixin
